export default "__VITE_ASSET__30388c75__"